import { useSelector } from 'react-redux';
import { selectors as routeSelectors } from '@clearscore/redux.routes';

const useSegmentation = () => {
    const routes = useSelector(routeSelectors.routesSelector);

    const routeWithSegmentation = (routes ?? []).find((route) => route.routeProps?.segmentation?.groups?.length);

    return routeWithSegmentation?.routeProps?.segmentation ?? { groups: [] };
};

/**
 * Check if a user has any of the argument groups
 * @param  {...string} requestedGroups groups to check for
 */
export const useHasSegmentationGroups = (...requestedGroups) => {
    const { groups } = useSegmentation();

    return requestedGroups.some((rg) => groups.includes(rg));
};

export const useExperiment = (experimentName, variantMap) => {
    const { groups } = useSegmentation();

    const selectedVariant = Object.keys(variantMap).find((variant) => groups.includes(`${experimentName}:${variant}`));

    if (selectedVariant) {
        return variantMap[selectedVariant];
    }

    return variantMap.control || null;
};

export default useSegmentation;
